// Palette
import palette from '../palette';

export default {
  outlined: {},
  outlinedPrimary: {
    color: palette.primary.main,
    borderColor: palette.primary.main,
    '&:hover': {
      backgroundColor: `${palette.primary.main}10`,
      borderColor: palette.primary.main,
    },
  },
  contained: {
    backgroundColor: palette.common.white,
    '&:hover': {
      backgroundColor: palette.common.neutral,
    },
  },
  containedPrimary: {
    backgroundColor: palette.primary.main,
    color: palette.common.white,
    '&:hover': {
      backgroundColor: '#E6493E',
    },
  },
  text: {
    padding: '9px 8px',
  },
  textPrimary: {
    color: palette.primary.main,
  },
};
